import { helpers } from '../helpers.js';

var repertoirFilter = {
  options: {
    // global options
  },

  selectors: {
    list: '.js_repertoir_filter_list',
    input_date: '.js_repertoir_filter_date',
    input_place: '.js_repertoir_filter_select_place',
    reset_button: '.js_repertoir_filter_reset',
    empty_text: '.js_repertoir_filter_empty',
  },

  init: function () {
    const self = this;

		if (!jQuery(self.selectors.list).length) {
			return;
		}

    self.preparePlaces();
		self.bindEvents();
  },

  preparePlaces: function () {
    const self = this;

		jQuery(self.selectors.list).find('li').each(function () {
			const $item = jQuery(this);
			const place = $item.data('place');

			if (place && !jQuery(self.selectors.input_place).find(`option[value="${place}"]`).length) {
				jQuery(self.selectors.input_place).append(new Option(place, place));
			}
		});
  },

  bindEvents: function () {
    const self = this;

    jQuery(self.selectors.input_place).on('change', function () {
      self.filterList();
    });

    jQuery(self.selectors.input_date).on('input', function () {
      self.filterList();
    });

    jQuery(self.selectors.reset_button).on('click', function (e) {
      e.preventDefault();
      self.resetFilters();
    });
  },

  filterList: function () {
    const self = this;

    const selectedPlace = jQuery(self.selectors.input_place).val();
    const selectedDate = jQuery(self.selectors.input_date).val();

    let dateStart = null, dateEnd = null;
    if (selectedDate && selectedDate.includes(' - ')) {
      const parts = selectedDate.split(' - ');
      dateStart = parts[0].trim();
      dateEnd = parts[1].trim();
    }

    jQuery(self.selectors.list).find('li').each(function () {
      const $item = jQuery(this);
      const itemPlace = $item.data('place');
      const itemDate = $item.data('date');

      let show = true;

      // Place filter (AND logic)
      if (selectedPlace && itemPlace !== selectedPlace) {
        show = false;
      }

      // Date filter (AND logic)
      if (show && dateStart && dateEnd && itemDate) {
        const selFormat = 'DD.MM.YYYY';
        const itemFormat = 'YYYY-MM-DD';
        const selStart = moment(dateStart, selFormat);
        const selEnd = moment(dateEnd, selFormat);
        // If either selected date is invalid, skip date filtering
        if (!selStart.isValid() || !selEnd.isValid()) {
          // do not filter by date
        } else {
          // itemDate is always in 'YYYY-MM-DD' format, can be single date or range
          let itemDateStart = itemDate, itemDateEnd = itemDate;
          if (itemDate.includes(' - ')) {
            const itemParts = itemDate.split(' - ');
            itemDateStart = itemParts[0].trim();
            itemDateEnd = itemParts[1].trim();
          }
          const itmStart = moment(itemDateStart, itemFormat);
          const itmEnd = moment(itemDateEnd, itemFormat);
          if (itmEnd.isBefore(selStart) || itmStart.isAfter(selEnd)) {
            show = false;
          }
        }
      }

      if (show) {
        $item.show();
      } else {
        $item.hide();
      }
    });

    // empty text
    if (jQuery(self.selectors.list).find('li:visible').length === 0) {
      jQuery(self.selectors.empty_text).removeClass('d-none');
    } else {
      jQuery(self.selectors.empty_text).addClass('d-none');
    }

    // show/hide reset filter button
    if (jQuery(self.selectors.input_place).val() || jQuery(self.selectors.input_date).val()) {
      jQuery(self.selectors.reset_button).removeClass('d-none');
    } else {
      jQuery(self.selectors.reset_button).addClass('d-none');
    }
  },

  resetFilters: function () {
    const self = this;

    jQuery(self.selectors.input_place).val('');
    jQuery(self.selectors.input_date).val('');
    self.filterList();
  }
}

// Export
export { repertoirFilter };